"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/descriptions/style/css");

var _descriptions = _interopRequireDefault(require("antd/es/descriptions"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _reactRedux = require("react-redux");

var _testkit = require("../../redux/testkit/testkit.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _descriptions.default;
const inputStyle = {
  marginTop: '5px',
  marginBottom: '5px'
};

class TestkitRequestedCard extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      reportDate: undefined
    };

    this.handleHemaspotReceipt = () => {
      const {
        reviewTestkit,
        testkit
      } = this.props;
      const {
        reportDate
      } = this.state;
      const reviewArg = {
        id: testkit.id,
        reportDate
      };
      reviewTestkit(reviewArg);
    };
  }

  onChange(state) {
    this.setState(state);
  }

  render() {
    const {
      testkit,
      trackingNumber
    } = this.props;
    const {
      participant
    } = testkit;

    if (!participant) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Participant Not Found.");
    }

    return /*#__PURE__*/_react.default.createElement(_descriptions.default, {
      layout: "vertical",
      column: testkit.type.match(/oraquick/i) ? 5 : 6
    }, /*#__PURE__*/_react.default.createElement(Item, {
      label: "Fulfillment"
    }, /*#__PURE__*/_react.default.createElement("span", null, `${testkit.firstName} ${testkit.lastName}`), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, `${testkit.address1}`), /*#__PURE__*/_react.default.createElement("br", null), testkit.address2 ? /*#__PURE__*/_react.default.createElement("span", null, `${testkit.address2}`, /*#__PURE__*/_react.default.createElement("br", null)) : '', /*#__PURE__*/_react.default.createElement("span", null, `${testkit.city}, ${testkit.state} ${testkit.postalCode}`), /*#__PURE__*/_react.default.createElement("br", null)), /*#__PURE__*/_react.default.createElement(Item, {
      label: "Type"
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontSize: '18px',
        fontWeight: 'bold'
      }
    }, `${testkit.type}`)), /*#__PURE__*/_react.default.createElement(Item, {
      label: "Tracking ID:"
    }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${testkit.trackingNumber}`
    }, testkit.trackingNumber))), /*#__PURE__*/_react.default.createElement(Item, {
      label: "USPS Delivered Date"
    }, /*#__PURE__*/_react.default.createElement("span", null, testkit.deliveredDate && testkit.receivedDate ? (0, _moment.default)(testkit.deliveredDate).calendar() : 'Kit not yet delivered according to USPS.')), "$", testkit.type.match(/oraquick/i) ? undefined : /*#__PURE__*/_react.default.createElement(Item, {
      label: "Actions"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this.handleHemaspotReceipt,
      disabled: !this.state.reportDate,
      style: {
        marginTop: '5px'
      }
    }, "Mark Received"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      placeholder: "Report Date",
      style: inputStyle,
      onChange: (date, dateString) => this.onChange({
        reportDate: dateString
      })
    }))));
  }

}

const mapDispatchToProps = dispatch => {
  return {
    reviewTestkit: testkit => dispatch(_testkit.reviewTestkitAsync.request(testkit))
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(TestkitRequestedCard);

exports.default = _default;